import { TagSchema } from "@redotech/redo-common-model/tag";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const addTagToReturn = {
  name: "addTagToReturn" as const,
  input: z.object({ returnId: zExt.objectId(), tag: TagSchema }),
  output: z.null(),
};
